import '@/store/api/product-inventory/typedefs'
import api from '@/store/api/product-inventory'
import * as mutationTypes from './mutation-types'

const initialState = () => ({
    metricType: {}
})

const state = initialState()

export default {
    namespaced: true,
    state,
    getters: {
        metricType: state => state.metricType
    },
    actions: {
        /**
         * @param {ProductQuery} data
         * @returns {Promise<*>}
         */
        showMetricType: async ({commit, dispatch}, data) => {
            try {
                const response = await api.metricTypes.showMetricType(data)
                commit(mutationTypes.SET_METRIC_TYPE, response)
                return response
            } catch (e) {
                const errorResponse = await dispatch('errors/addErrors', [e], {root: true})
                return Promise.reject(errorResponse[0])
            }
        },
        /**
         * @param {MetricType} data
         * @returns {Promise<*>}
         */
        createMetricType: async ({dispatch}, data) => {
            try {
                return await api.metricTypes.createMetricType(data)
            } catch (e) {
                const errorResponse = await dispatch('errors/addErrors', [e], {root: true})
                return Promise.reject(errorResponse[0])
            }
        },
        /**
         * @param {MetricType} data
         * @returns {Promise<*>}
         */
        updateMetricType: async ({dispatch}, data) => {
            try {
                return await api.metricTypes.updateMetricType(data)
            } catch (e) {
                const errorResponse = await dispatch('errors/addErrors', [e], {root: true})
                return Promise.reject(errorResponse[0])
            }
        },
        /**
         * @param {MetricType} data
         * @returns {Promise<*>}
         */
        removeMetricType: async ({dispatch}, data) => {
            try {
                return await api.metricTypes.removeMetricType(data)
            } catch (e) {
                const errorResponse = await dispatch('errors/addErrors', [e], {root: true})
                return Promise.reject(errorResponse[0])
            }
        },
        resetMetricType: async ({commit}) => commit(mutationTypes.RESET_METRIC_TYPE)
    },
    mutations: {
        [mutationTypes.SET_METRIC_TYPE]: (state, data) => state.metricType = data,
        [mutationTypes.RESET_METRIC_TYPE]: (state) => Object.assign(state, initialState())
    }
}
